module.exports = __webpack_public_path__ + "static/media/upper.19d762b9.ogg";